import React from 'react';
import { theme } from '../styles/theme';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';

export const AgencyDashboardPage = () => {
  // Mock data
  const agency = {
    name: 'Sterling Literary Agency',
    agentCount: 8,
    foundedYear: 2015,
  };

  const stats = {
    totalQueries: 1247,
    activeManuscripts: 34,
    offersThisMonth: 5,
    dealsThisYear: 18,
    responseRate: 92,
    avgResponseTime: 21, // days
  };

  const agents = [
    {
      id: 1,
      name: 'Sarah Johnson',
      title: 'Senior Agent',
      photo: '👩‍💼',
      genres: ['Literary Fiction', 'Thriller'],
      activeQueries: 43,
      requestedMSS: 8,
      queryStatus: 'open',
    },
    {
      id: 2,
      name: 'Michael Chen',
      title: 'Agent',
      photo: '👨‍💼',
      genres: ['Science Fiction', 'Fantasy'],
      activeQueries: 38,
      requestedMSS: 5,
      queryStatus: 'closed',
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      title: 'Agent',
      photo: '👩‍💼',
      genres: ['Romance', 'Women\'s Fiction'],
      activeQueries: 52,
      requestedMSS: 12,
      queryStatus: 'open',
    },
    {
      id: 4,
      name: 'David Park',
      title: 'Agent',
      photo: '👨‍💼',
      genres: ['Mystery', 'Thriller'],
      activeQueries: 29,
      requestedMSS: 4,
      queryStatus: 'open',
    },
    {
      id: 5,
      name: 'Jennifer Williams',
      title: 'Junior Agent',
      photo: '👩‍💼',
      genres: ['YA Fantasy', 'Contemporary'],
      activeQueries: 31,
      requestedMSS: 3,
      queryStatus: 'open',
    },
  ];

  const recentActivity = [
    {
      id: 1,
      type: 'offer',
      agent: 'Sarah Johnson',
      description: 'Made an offer on "The Silent Shore" by Emma Rodriguez',
      timestamp: '2 hours ago',
      icon: '✓',
      color: theme.colors.success,
    },
    {
      id: 2,
      type: 'deal',
      agent: 'Emily Rodriguez',
      description: 'Closed 3-book deal with HarperCollins for client Jane Smith',
      timestamp: '5 hours ago',
      icon: '🎉',
      color: theme.colors.primary,
    },
    {
      id: 3,
      type: 'request',
      agent: 'Michael Chen',
      description: 'Requested full manuscript for "Code Breakers"',
      timestamp: '1 day ago',
      icon: '📖',
      color: theme.colors.info,
    },
    {
      id: 4,
      type: 'query',
      agent: 'David Park',
      description: 'Received 12 new queries today',
      timestamp: '1 day ago',
      icon: '📨',
      color: theme.colors.textSecondary,
    },
    {
      id: 5,
      type: 'client',
      agent: 'Jennifer Williams',
      description: 'Signed new client for YA Fantasy series',
      timestamp: '2 days ago',
      icon: '✍️',
      color: theme.colors.success,
    },
    {
      id: 6,
      type: 'request',
      agent: 'Sarah Johnson',
      description: 'Requested partial manuscript for "Beyond the Horizon"',
      timestamp: '3 days ago',
      icon: '📖',
      color: theme.colors.info,
    },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      fontFamily: theme.fonts.primary,
    }}>
      <Header />

      <main style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '60px 40px',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '32px',
        }}>
          <div>
            <h1 style={{
              fontSize: '40px',
              fontWeight: '400',
              marginBottom: '8px',
              color: theme.colors.textPrimary,
            }}>
              {agency.name}
            </h1>
            <p style={{
              fontSize: '18px',
              color: theme.colors.textSecondary,
            }}>
              Agency Dashboard • {agency.agentCount} Agents • Est. {agency.foundedYear}
            </p>
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <Button
              variant="outline"
              onClick={() => window.location.href = '/agency/agents'}
            >
              Manage Agents
            </Button>
            <Button
              onClick={() => window.location.href = '/agency/profile/edit'}
            >
              Edit Profile
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '20px',
          marginBottom: '40px',
        }}>
          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.primary,
              marginBottom: '8px',
            }}>
              {stats.totalQueries}
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Total Queries
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              This Month
            </div>
          </Card>

          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.info,
              marginBottom: '8px',
            }}>
              {stats.activeManuscripts}
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Active Manuscripts
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              Under Review
            </div>
          </Card>

          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.success,
              marginBottom: '8px',
            }}>
              {stats.offersThisMonth}
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Offers Made
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              This Month
            </div>
          </Card>

          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.warning,
              marginBottom: '8px',
            }}>
              {stats.dealsThisYear}
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Deals Closed
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              This Year
            </div>
          </Card>

          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.primary,
              marginBottom: '8px',
            }}>
              {stats.responseRate}%
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Response Rate
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              Agency Average
            </div>
          </Card>

          <Card style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
            <div style={{
              fontSize: '36px',
              fontWeight: '500',
              color: theme.colors.info,
              marginBottom: '8px',
            }}>
              {stats.avgResponseTime}d
            </div>
            <div style={{
              fontSize: '14px',
              color: theme.colors.textSecondary,
              marginBottom: '4px',
            }}>
              Avg Response Time
            </div>
            <div style={{
              fontSize: '12px',
              color: theme.colors.textTertiary,
            }}>
              Agency Average
            </div>
          </Card>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: '24px',
        }}>
          {/* Agent Roster */}
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
            }}>
              <h2 style={{
                fontSize: '24px',
                fontWeight: '500',
                color: theme.colors.textPrimary,
                margin: 0,
              }}>
                Agent Roster
              </h2>
              <Button
                variant="outline"
                size="small"
                onClick={() => window.location.href = '/agency/agents'}
              >
                View All
              </Button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {agents.map((agent) => (
                <Card key={agent.id}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                  }}>
                    <div style={{ display: 'flex', gap: '16px', flex: 1 }}>
                      <div style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        backgroundColor: theme.colors.backgroundAlt,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '28px',
                      }}>
                        {agent.photo}
                      </div>

                      <div style={{ flex: 1 }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          marginBottom: '6px',
                        }}>
                          <h3 style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            color: theme.colors.textPrimary,
                            margin: 0,
                          }}>
                            {agent.name}
                          </h3>
                          <Badge variant={agent.queryStatus === 'open' ? 'success' : 'default'}>
                            {agent.queryStatus === 'open' ? 'Open to Queries' : 'Closed'}
                          </Badge>
                        </div>

                        <div style={{
                          fontSize: '14px',
                          color: theme.colors.textSecondary,
                          marginBottom: '8px',
                        }}>
                          {agent.title}
                        </div>

                        <div style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '6px',
                          marginBottom: '12px',
                        }}>
                          {agent.genres.map((genre) => (
                            <Badge key={genre} variant="default">
                              {genre}
                            </Badge>
                          ))}
                        </div>

                        <div style={{
                          display: 'flex',
                          gap: '20px',
                          fontSize: '13px',
                          color: theme.colors.textSecondary,
                        }}>
                          <div>
                            <strong>{agent.activeQueries}</strong> Active Queries
                          </div>
                          <div>
                            <strong>{agent.requestedMSS}</strong> Requested MSS
                          </div>
                        </div>
                      </div>
                    </div>

                    <Button
                      variant="ghost"
                      size="small"
                      onClick={() => window.location.href = `/agents/${agent.id}`}
                    >
                      View Profile
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '500',
              color: theme.colors.textPrimary,
              marginBottom: '20px',
            }}>
              Recent Activity
            </h2>

            <Card style={{ padding: '16px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {recentActivity.map((activity) => (
                  <div key={activity.id} style={{
                    display: 'flex',
                    gap: '12px',
                    paddingBottom: '20px',
                    borderBottom: activity.id !== recentActivity.length ? `1px solid ${theme.colors.border}` : 'none',
                  }}>
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: theme.colors.backgroundAlt,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '18px',
                      flexShrink: 0,
                    }}>
                      {activity.icon}
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontSize: '13px',
                        fontWeight: '500',
                        color: activity.color,
                        marginBottom: '4px',
                      }}>
                        {activity.agent}
                      </div>
                      <div style={{
                        fontSize: '14px',
                        color: theme.colors.textPrimary,
                        marginBottom: '4px',
                        lineHeight: '1.4',
                      }}>
                        {activity.description}
                      </div>
                      <div style={{
                        fontSize: '12px',
                        color: theme.colors.textTertiary,
                      }}>
                        {activity.timestamp}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card>

            {/* Quick Actions */}
            <div style={{ marginTop: '24px' }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '500',
                color: theme.colors.textPrimary,
                marginBottom: '16px',
              }}>
                Quick Actions
              </h3>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Button
                  variant="outline"
                  onClick={() => window.location.href = '/agency/agents'}
                  style={{ justifyContent: 'flex-start' }}
                >
                  👥 Manage Agents
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.location.href = '/agency/settings'}
                  style={{ justifyContent: 'flex-start' }}
                >
                  ⚙️ Agency Settings
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.location.href = '/agency/profile/edit'}
                  style={{ justifyContent: 'flex-start' }}
                >
                  ✏️ Edit Profile
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
